//===========================================================
// Page Actions
//===========================================================
export const SEND_CONTACT_FORM = "send_contact_form",
  CLEAR_MESSAGE = "clear_message",
  STATIC_ERROR = "static_error";
